
const getters = {
  isJida: state => state.settings.isJida,
  fileApi: state => state.settings.fileApi,
  clientId: state => state.settings.clientId,
  clientSecret: state => state.settings.clientSecret,
  otherClientId: state => state.settings.otherClientId,
  otherClientSecret: state => state.settings.otherClientSecret,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  userName: state => state.user.userName,
  fullName: state => state.user.fullName,
  roles: state => state.user.roles,
  supplier: state => state.setStore.supplier,
  viewObj: state => state.setStore.viewObj,
  viewList: state => state.setStore.viewList,
  routes: state => state.permission.routes
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js